import React from 'react';
import CCAmexImage from '../../../img/cc-amex.png';
import CCMasterCardImage from '../../../img/cc-mastercard.png';
import CCVisaImage from '../../../img/cc-visa.png';
import CCDiscoverImage from '../../../img/cc-discover.png';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { CreditCardTypeEnum } from '../../../services/V2/gozer';

const CCImage = ({ token, className }) => {
    if(!token) return <>CC</>
    switch (token.cardType) {
        case CreditCardTypeEnum.AMERICAN_EXPRESS:
            return <img className={className} src={CCAmexImage} alt="American Express" />
        case CreditCardTypeEnum.DISCOVER:
            return <img className={className} src={CCDiscoverImage} alt="Discover" />
        case CreditCardTypeEnum.MASTER_CARD:
            return <img className={className} src={CCMasterCardImage} alt="Mastercard" />
        case CreditCardTypeEnum.VISA:
            return <img className={className} src={CCVisaImage} alt="Visa" />
        default:
            return <CreditCardIcon
                className={className}
                style={{ marginRight: ".5em" }}
                aria-label="Credit card"
                key="cc" />
    }
}

export default CCImage;